import type { Theme } from '@mui/material/styles';

/** MUI spacing units (8px). Density reduces whitespace, never body/input text. */
export const MOBILE_DENSITY = {
  pageInset: 1.5,
  cardInset: 1.5,
  sectionGap: 2,
  inputFontSize: 16,
  touchTarget: 44,
  progressRing: 100,
} as const;

export const phoneMedia = (theme: Theme) => theme.breakpoints.down('sm');
